import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Type } from '@spotify-internal/encore-creator-web';
import styles from './index.module.scss';
import {
  selectNetworkStartsStreamsStatus,
  selectNetworkStartsStreams,
  selectDateRange,
  LOADING,
  ERROR,
} from '../../../store/selectors';
import { loadNetworkStartsStreams } from '../../../store/networkStartsStreams';
import { StartsStreams } from '../../../components/Shared/Charts/StartsStreamsChart';
import { LoadingIndicator } from '../../../components/Shared/LoadingIndicator';
import { DetailedStream, DateRangeWithLabel, ReduxState } from '../../../types';
import { FormattedMessage } from 'react-intl';

type Props = {
  networkId: string;
  status?: 'LOADING' | 'ERROR';
  loadNetworkStartsStreams: typeof loadNetworkStartsStreams;
  networkStartsStreams?: DetailedStream[];
  dateRange?: DateRangeWithLabel;
};

export class NetworkStartsStreamsContainer extends PureComponent<Props> {
  componentDidMount() {
    this.props.loadNetworkStartsStreams(this.props.networkId);
  }

  /* istanbul ignore next */
  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (!this.props.dateRange || !nextProps.dateRange) {
      return;
    }

    if (
      nextProps.dateRange.startDate !== this.props.dateRange.startDate ||
      nextProps.dateRange.endDate !== this.props.dateRange.endDate
    ) {
      this.props.loadNetworkStartsStreams(this.props.networkId);
    }
  }

  render() {
    if (this.props.status === ERROR) {
      return <span data-qa="network-starts-streams-error" />;
    }

    if (!this.props.networkStartsStreams && this.props.status !== LOADING) {
      return null;
    }

    return (
      <div data-qa="network-starts-streams-chart" className={styles.container}>
        <Type as="p" variant={Type.heading3}>
          <FormattedMessage
            id="network.audience.starts-streams.title"
            description="Title of starts and streams chart"
            defaultMessage="Starts & Streams"
          />
        </Type>
        {this.props.status === LOADING ? (
          <div style={{ width: '100%', height: '350px' }}>
            <LoadingIndicator />
          </div>
        ) : (
          <StartsStreams startsStreams={this.props.networkStartsStreams!} />
        )}
      </div>
    );
  }
}

const selectors = createStructuredSelector<
  ReduxState,
  {
    status: ReturnType<typeof selectNetworkStartsStreamsStatus>;
    networkStartsStreams: ReturnType<typeof selectNetworkStartsStreams>;
    dateRange: ReturnType<typeof selectDateRange>;
  }
>({
  status: selectNetworkStartsStreamsStatus,
  networkStartsStreams: selectNetworkStartsStreams,
  dateRange: selectDateRange,
});

const actions = {
  loadNetworkStartsStreams,
};

export const ConnectedNetworkStartsStreamsContainer = connect(
  selectors,
  actions,
)(NetworkStartsStreamsContainer);
